module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Login Required","message":"You must be logged in to perform this action","cta":"Login"},"ar":{"title":"تسجيل الدخول","message":"يجب عليك تسجيل الدخول للقيام بهذه العمليه","cta":"تسجيل الدخول"}}')
  delete Component.options._Ctor
}
